module.exports = __webpack_public_path__ + "static/media/person.ea51c224.svg";